import { render, staticRenderFns } from "./SectionProductRow.vue?vue&type=template&id=2ab34f0c&"
import script from "./SectionProductRow.vue?vue&type=script&lang=js&"
export * from "./SectionProductRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports